import { Box, Grid, Icon, Stack, Typography } from "@mui/material";

export const ProductionChartStoreList = ({ stores }) => {
  return (
    <Stack
      sx={{
        backgroundColor: "#F7FAFC",
        width: "100%",
      }}
    ></Stack>
  );
};
